module.exports = __webpack_public_path__ + "506e67b004527404a091087a16223da0.png";